import { Injectable } from '@angular/core';
import { PayJustNowApi } from '../../api/pay-just-now/pay-just-now-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PayJustNowService {

  constructor(private payJustNowApi:PayJustNowApi) { }

  public initialize(sessionToken : string):Observable<any>{
    return this.payJustNowApi.initialize(sessionToken);
  }

  public validate(sessionToken : string):Observable<any>{
    return this.payJustNowApi.validate(sessionToken);
  }
}
